import { render, staticRenderFns } from "./SNOT22.vue?vue&type=template&id=8336c5c8&scoped=true&lang=pug&"
import script from "./SNOT22.vue?vue&type=script&lang=js&"
export * from "./SNOT22.vue?vue&type=script&lang=js&"
import style0 from "./SNOT22.vue?vue&type=style&index=0&id=8336c5c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8336c5c8",
  null
  
)

export default component.exports